<template >
    
        <div style="position:fixed;
        width: 100%;z-index: 99;
        min-width: 320px;
        max-width: 540px;"
        v-if="tb.text"
        >
            <van-notice-bar 
            scrollable 
            :text="tb.text"
            mode="closeable"
            color="#1989fa" 
            background="#ecf9ff" 
            left-icon="info-o"
            />
        </div>
    

</template>


<script>
import Vue from 'vue';
import { NoticeBar } from 'vant';
Vue.use(NoticeBar);
export default{
    props:["tb"],

}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/fields/NoticeBar.vue